export const INPUT_CHECK_ALL_VALUE = 'check-all'
